import axios from 'axios';
import env from '../../env';

export const ProductsService = {

    async getAll() {
        return axios.post(env.API + '/products/all');
    },

    async getAllParams(retails, categories, countries, brands) {
        return axios.post(env.API + '/products/all', {
            retails: retails,
            categories: categories,
            countries: countries,
            brands: brands,
        },{headers:{'page-size': 50}})
    },

    async getAllParamsPage(retails, categories, countries, brands, pages, name = '', pageSize = 50) {
        return axios.post(env.API + '/products/all', {
            retails: retails,
            categories: categories,
            countries: countries,
            brands: brands,
            page: pages,
            name,

        },{headers:{'page-size': pageSize}})
    },

    async getNameUnique(retails, categories, countries, brands, pages, name, features, unique) {
        return axios.post(env.API + '/products/all', {
            retails: retails,
            categories: categories,
            countries: countries,
            brands: brands,
            page: pages,
            name: name,
            features: features,
            unique: unique
        },{headers:{'page-size': 50}})
    },

    async getPendingParamPage(pages, country, retails, categories, brands, start_date, end_date, name, limit = 20){
        console.log(pages)
        return axios.post(env.API + '/products/pending', {
            page: pages,
            countries: [country],
            retails: retails,
            categories: categories,
            brands: brands,
            start_date: start_date,
            end_date: end_date,
            name: name,
            last_seen_products: env.USE_TAXO_TABLE ? false : true,
        },{headers:{'page-size': limit}})
    },

    async getPending(country, retails, categories, brands, start_date, end_date, name) {
        return axios.post(env.API + '/products/pending', {
            countries: [country],
            retails: retails,
            categories: categories,
            brands: brands,
            start_date: start_date,
            end_date: end_date,
            name: name,
            last_seen_products: env.USE_TAXO_TABLE ? false : true,
        },{headers:{'page-size': 20}})
    },

    async getPendingCount(country, retails, categories, brands, start_date, end_date, name, limit = 20){
        return axios.post(env.API + '/products/pending/count', {
            countries: [country],
            retails: retails,
            categories: categories,
            brands: brands,
            start_date: start_date,
            end_date: end_date,
            name: name,
            last_seen_products: env.USE_TAXO_TABLE ? false : true,
        },{headers:{'page-size': limit}})
    },

    async getDescartadosCount(country, retails, categories, brands, start_date, end_date, name){
        return axios.post(env.API + '/products/removed/count', {
            countries: [country],
            retails: retails,
            categories: categories,
            brands: brands,
            start_date: start_date,
            end_date: end_date,
            name: name
        },{headers:{'page-size': 50}})
    },

    async getDescartados(country, retails, categories, brands, start_date, end_date, name){
        return axios.post(env.API + '/products/removed',{
            countries: [country],
            retails: retails,
            categories: categories,
            brands: brands,
            start_date: start_date,
            end_date: end_date,
            name: name
        },{headers:{'page-size': 50}});
    },

    async getDescartadosParams(country, retails, categories, pages, brands, start_date, end_date, name){
        return axios.post(env.API + '/products/removed',{
            countries: [country],
            retails: retails,
            categories: categories,
            page: pages,
            brands: brands,
            start_date: start_date,
            end_date: end_date,
            name: name
        },{headers:{'page-size': 50}});
    },

    async postTaxonomizado(name, brand, md5, feature1, feature2, feature3, feature4, feature5, category) {
        return axios.post(env.API + '/products', {
            name: name,
            brand_id: brand,
            md5_link: md5,
            feature_1: feature1,
            feature_2: feature2,
            feature_3: feature3,
            feature_4: feature4,
            feature_5: feature5,
            category_id: category
        });
    },

    async postEditTaxonomizado(id, name, brand, md5, feature1, feature2, feature3, feature4, feature5, category) {
        return axios.post(env.API + '/products', {
            id: id,
            name: name,
            brand_id: brand,
            md5_link: md5,
            feature_1: feature1,
            feature_2: feature2,
            feature_3: feature3,
            feature_4: feature4,
            feature_5: feature5,
            category_id: category
        });
    },

    async softDelete(md5){
        return axios.delete(env.API + '/products/pending/'+md5);
    },

    async getNames(name, brand_id, category_id = ''){
        return axios.post(env.API + '/products/autocomplete',{
            name: name,
            brand_id: brand_id,
            category_id,
        })
    },

    async getProductNamesAutocomplete(name, country, retails, categories, brands) {
        return axios.post(env.API + '/product_name/autocomplete',{
            name: name,
            countries: country ? [country] : null,
            retails: retails,
            categories: categories,
            brands: brands
        })
    },

    async retrocederDadosByMd5(md5){
        return axios.delete(env.API + '/products/removed/'+ md5);
    },

    async comparative(obj, count = false){
        return axios.post(env.API + "/products/comparative",{
            date: obj.date,
            country: obj.country,
            retails: obj.retails,
            categories: obj.categories,
            brands: obj.brands,
            count: count,
            page: obj.page
        },{headers:{'page-size': 50}})
    },

    async historico(obj, limit = 100, offset = 0, count = false){
        return axios.post(env.API + "/products/history",{
            start_date: obj.date.desde,
            end_date: obj.date.hasta,
            countries: [obj.country],
            retails: obj.retails,
            categories: obj.categories,
            brands: obj.brands,
            limit: limit,
            offset: offset,
            count: count
        })
    },

    async postEditMD5_GROUP(name, brand, md5, feature1, feature2, feature3, feature4, feature5, category) {
        return axios.post(env.API + "/products", {
            name: name,
            brand_id: brand,
            md5_group: md5,
            unique: true,
            feature_1: feature1,
            feature_2: feature2,
            feature_3: feature3,
            feature_4: feature4,
            feature_5: feature5,
            category_id: category
        })
    }
}